import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { useIntl, FormattedMessage, defineMessages } from "react-intl";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import { DatePicker } from "@material-ui/pickers";
import { theme } from "./datePickerTheme";
import CalendarIcon from "../icons/calendarIcon";

const messages = defineMessages({
    selectDateTitle: {
        id: "select-date-domain.title",
        defaultMessage: "Select date range: ",
        description: "Select date range caption",
    },
    cancel: {
        id: "select-date-domain.cancel-caption",
        defaultMessage: "Cancel",
        description: "Cancel selected date range",
    },
    accept: {
        id: "select-date-domain.accept-caption",
        defaultMessage: "Apply",
        description: "Apply selected date range",
    },
});

export const CMISDatePicker = (props) => {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const [date, setDate] = useState(props.value);

    // make sure the date value always starts with the same value as the text field

    useEffect(() => {
        setDate(props.value);
    }, [isOpen]);

    return (
        <React.Fragment>
            <DatePicker
                {...props}
                variant="inline"
                label={intl.formatMessage(messages.selectDateTitle)}
                cancelText={intl.formatMessage(messages.cancel)}
                okText={intl.formatMessage(messages.accept)}
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                value={date}
                onChange={setDate}
                onAccept={props.onChange}
                placeholder={""}
                helperText={""}
                format="dd/MM/yyyy"
                renderInput={(props) => {
                    props.helperText = "";
                    props.inputProps.placeholder = "";
                    props.InputProps.onClick = () => setIsOpen(true);
                    props.InputProps.endAdornment = (
                        <IconButton onClick={() => setIsOpen(true)}>
                            <CalendarIcon />
                        </IconButton>
                    );
                    return <TextField {...props} helperText={""} placeholder={""} fullWidth />;
                }}
            />
        </React.Fragment>
    );
};

export default CMISDatePicker;
